import { useEffect } from 'react';

const useIsScrolling = (startScrolling, stopScrolling, timeout = 500) => {
  let handle = null;

  const handleScroll = () => {
    if (!handle) {
      startScrolling();
    }

    clearTimeout(handle);

    handle = setTimeout(() => {
      stopScrolling();
      handle = null;
    }, timeout);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { startScrolling, stopScrolling };
};

export default useIsScrolling;
